import { ClipboardModule } from '@angular/cdk/clipboard';
import { OVERLAY_DEFAULT_CONFIG, OverlayModule } from '@angular/cdk/overlay';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GoogleAnalyticsService } from 'analytics-lib';
import { AutoCompleteComponent } from 'auto-complete-lib';
import { BullhornRetryInterceptor } from 'datasource-service-lib';
import { SalesforceEntityIconComponent } from 'entity-icon-lib';
import { ENVIRONMENT, RUNTIME_ENVIRONMENT } from 'environments-lib';
import { SentenceCasePipe } from 'pipes-lib';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { AdcMigrationComponent } from './components/adc-migration/adc-migration.component';
import { BBarComponent } from './components/debugging/bbar.component';
import { DebuggerComponent } from './components/debugging/debugger/debugger.component';
import { DebuggingComponent } from './components/debugging/debugging.component';
import { DocusignComponent } from './components/esignature/docusign/docusign.component';
import { DocusignOptionsComponent } from './components/esignature/docusign/options/docusign-options.component';
import { AiAssistPromptComponent } from './components/field-selection/ai-assist-prompt/ai-assist-prompt.component';
import { BreadcrumbsComponent } from './components/field-selection/breadcrumbs/breadcrumbs.component';
import { ConditionalFieldsComponent } from './components/field-selection/conditional-fields/conditional-fields.component';
import { DataFieldsComponent } from './components/field-selection/data-fields/data-fields.component';
import { DocumentSenderComponent } from './components/field-selection/document-sender/document-sender.component';
import { EntitySelectionComponent } from './components/field-selection/entity-selection/entity-selection.component';
import { FieldConfigComponent } from './components/field-selection/field-config/field-config.component';
import { BlankFieldDefaultComponent } from './components/field-selection/field-config/field-options/blank-field-default/blank-field-default.component';
import { ConditionsComponent } from './components/field-selection/field-config/field-options/conditions/conditions.component';
import { DateFormatComponent } from './components/field-selection/field-config/field-options/date-format/date-format.component';
import { FormatDecimalComponent } from './components/field-selection/field-config/field-options/format-number/decimal-formatter/format-decimal.component';
import { FormatIntegerComponent } from './components/field-selection/field-config/field-options/format-number/integer-formatter/format-integer.component';
import { LimitComponent } from './components/field-selection/field-config/field-options/limit/limit.component';
import { PresentationOptionsComponent } from './components/field-selection/field-config/field-options/presentation/presentation-options.component';
import { SortOptionsComponent } from './components/field-selection/field-config/field-options/sort-options/sort-options.component';
import { StringFormatComponent } from './components/field-selection/field-config/field-options/string-format/string-format.component';
import { FieldSelectionSkeletonComponent } from './components/field-selection/field-selection-skeleton/field-selection-skeleton.component';
import { FieldSelectionComponent } from './components/field-selection/field-selection.component';
import { FooterComponent } from './components/field-selection/footer/footer.component';
import { ImageFieldsComponent } from './components/field-selection/image-fields/image-fields.component';
import { ScriptFieldsComponent } from './components/field-selection/script-fields/script-fields.component';
import { FilterableListComponent } from './components/filterable-list/filterable-list.component';
import { LoginComponent } from './components/login/login.component';
import { SkeletonComponent } from './components/skeleton/skeleton.component';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { VersionComponent } from './components/version/version.component';
import { WholeNumberOnlyDirective } from './directives/whole-number-only.directive';
import { AutoFocus } from './utils/autofocus.directive';

@NgModule({
  declarations: [
    AppComponent,
    AutoFocus,
    DateFormatComponent,
    ConditionsComponent,
    DocusignComponent,
    LimitComponent,
    LoginComponent,
    VersionComponent,
    SkeletonComponent,
    SortOptionsComponent,
    FormatIntegerComponent,
    FormatDecimalComponent,
    FilterableListComponent,
    BreadcrumbsComponent,
    FieldSelectionComponent,
    DataFieldsComponent,
    DocumentSenderComponent,
    EntitySelectionComponent,
    FieldConfigComponent,
    FooterComponent,
    FieldSelectionSkeletonComponent,
    DebuggingComponent,
    SentenceCasePipe,
    BBarComponent,
    BlankFieldDefaultComponent,
    StringFormatComponent,
    PresentationOptionsComponent,
    ScriptFieldsComponent,
    ImageFieldsComponent,
    ToolbarComponent,
    DocusignOptionsComponent,
    WholeNumberOnlyDirective,
    ConditionalFieldsComponent,
    AiAssistPromptComponent,
    DebuggerComponent,
    AdcMigrationComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatSelectModule,
    OverlayModule,
    FormsModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    MatListModule,
    MatIconModule,
    MatRippleModule,
    MatTabsModule,
    MatMenuModule,
    MatRadioModule,
    ClipboardModule,
    MatTooltipModule,
    AutoCompleteComponent,
    SalesforceEntityIconComponent,
  ],
  providers: [
    GoogleAnalyticsService,
    provideHttpClient(withInterceptorsFromDi()),
    { provide: ENVIRONMENT, useValue: environment },
    { provide: RUNTIME_ENVIRONMENT, useValue: undefined },
    { provide: HTTP_INTERCEPTORS, useClass: BullhornRetryInterceptor, multi: true }
  ],
})
export class AppModule {}
